import {useQuery} from '@tanstack/react-query';

// =============================================================================
// Query Key Factory
// =============================================================================

export const productionKeys = {
    all: ['productions'] as const,
    existsActive: () => [...productionKeys.all, 'exists-active'] as const,
};

// =============================================================================
// Fetch Functions
// =============================================================================

const fetchExistsActiveProduction = async (): Promise<boolean> => {
    const response = await fetch(
        `${window.environment.backend}api/1.0/productions/exists-active`,
        {credentials: 'include'}
    );

    if (!response.ok) {
        return false;
    }

    const data = await response.json();
    return data.result ?? false;
};

// =============================================================================
// Query Hooks
// =============================================================================

/**
 * Check if an active production exists
 * Used for role-based redirects (QM_RESPONSIBLE, SPORTCAST, ADMIN)
 */
export const useExistsActiveProductionQuery = (enabled: boolean = true) => {
    return useQuery({
        queryKey: productionKeys.existsActive(),
        queryFn: fetchExistsActiveProduction,
        enabled,
        staleTime: 30 * 1000, // 30 seconds
        retry: false,
    });
};
